import type { TFunction } from 'i18next'

/**
 * Agent Store and Workflow Store are cross-app destinations. They are not
 * owned by the sticky app, so the header must name the store itself.
 */
export function storeHeaderName(pathname: string, t: TFunction): string | undefined {
  if (pathname === '/agent-store' || pathname.startsWith('/agent-store/')) {
    return t('nav.agentStore')
  }
  if (pathname === '/workflow-store' || pathname.startsWith('/workflow-store/')) {
    return t('nav.workflowStore')
  }
  return undefined
}
